<div class="top-navigation">
  <div class="step" [class.current]="active === 1">{{ 'step1_registration' | translate }}</div>
  <app-ui-icon [iconName]="'icon-chevron-right'" [size]="16"></app-ui-icon>
  <div class="step" [class.current]="active === 2">{{ 'step2_personal' | translate }}</div>
</div>
